export const AdminPanelFooter = ({ buttonText, onButtonClick }) => (<div className='admin-panel__form-footer'>
    <button onClick={onButtonClick}>{buttonText}</button>
  </div>);
